export default {
  playable: {
    title: 'プレイ可能',
    download: 'プレイアブルのダウンロード/プッシュ',
    notes: '(Mintegralプッシュ無制限)',
    describe: '(使用可能 / 総額)',
    notesTip: 'Mintegralチャンネルであれば、素材の送信回数に制限なし',
  },
  video: {
    title: 'ビデオ',
    export: '動画エクスポート',
    clip: 'スマートなシナリオ',
    subtitle: 'スマートな字幕の識別',
    speech: 'スマートな吹き出し',
    clone: 'クローンされた音色の数',
  },
  expireDate: '有効期限',
  expireAfter: '残り{days}日',
  expired: 'あなたのサブスクリプションは期限切れです',
  current: {
    remaining: 'パッケージ内',
  },
  additional: {
    quota: '追加パッケージ',
  },
  unlimited: '制限なし',
  plan: {
    tips: '(利用可能/購入済み)',
  },
  online: {
    storage: 'オンラインストレージスペース',
    describe: '(使用済み / 総額)',
    exceedPrompt:
      'スペースがいっぱいの場合、新しいプロジェクトの作成および編集はできません。すぐに拡張またはクリーンアップしてください。',
  },
  subscriber: '正規',
  trial: 'トライアル',
  individual: '個人',
  enterprise: '企業',
  refresh: {
    time: 'パッケージ内のリフレッシュタイム',
  },
  details: {
    title: '残量の詳細',
  },
  unit: {
    coin: 'ポイント',
    time: '時間',
    item: 'アイテム',
  },
  usage: {
    videoCredit: {
      unit: {
        description:
          '異なるAIサービスの消費ポイント<br />- 動画AI消去：消去する動画の長さに基づいて計算され、45点/秒<br />- 音声認識：認識対象の動画または音声の長さに基づいて計算され、5点/分<br />- インテリジェントストーリーボード：検出対象の動画の長さに基づいて計算され、20点/分<br />- 音声クローン：音声音色をクローンするごとに240点消費<br />- 動画のエクスポート：エクスポートする動画の長さに基づいて計算され、15点/分<br />- AI画像生成：生成された画像の数に基づいて計算され、1枚あたり15ポイントです。',
      },
    },
  },
  subscribe: {
    now: '今すぐ更新',
    tips: '更新手続きについては担当者までお問い合わせください。',
    overtime:
      'お客様のご契約は期限切れです。再契約については営業担当者にご連絡ください。',
    overtime2:
      'あなたのサブスクリプションは期限切れですので、更新してください。',
    free: {
      tips: 'サービスがまだ開始されていません。今すぐ無料トライアルをお申し込みください！',
    },
    title: '更新',
    otherTitle: '残高不足',
    accountBalance: '口座残高',
    desc: '継続購入についてはサポート担当までご連絡ください。または、メールを<a href="mailto:sales@mindworks-creative.com">sales@mindworks-creative.com</a>宛に送信し、Playturboユーザー名をご記入ください。',
    otherDesc:
      '購入については担当者までご連絡ください。または、メールを<a href="mailto:sales@mindworks-creative.com">sales@mindworks-creative.com</a>宛に送信し、Playturboユーザー名をご記入ください。',
    ok: '了解しました',
  },
}
